import { render } from "./UpdateOrganization.vue?vue&type=template&id=762b3b77&scoped=true"
import script from "./UpdateOrganization.vue?vue&type=script&lang=js"
export * from "./UpdateOrganization.vue?vue&type=script&lang=js"

import "./UpdateOrganization.vue?vue&type=style&index=0&id=762b3b77&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762b3b77"]])

export default __exports__